/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { AxiosResponse } from 'axios'
import { z } from 'zod'

import * as CommonTypes from './common-types'
import * as CustomersTypes from './customers-types'
import * as OrdersTypes from './orders-types'
import * as ProductsTypes from './products-types'
import * as RootTypes from './root-types'
import * as SalesChannelsTypes from './sales-channels-types'
import * as StoreLoyaltyCardTypes from './store-loyalty-card-types'

export enum HttpMethod {
	Get = 'GET',
	Post = 'POST',
	Put = 'PUT',
	Delete = 'DELETE',
	Patch = 'PATCH'
}

export enum Endpoint {
	/**
	 * @example Path*
/v1/store/version-info*/
	GetVersionInfo = 'GetVersionInfo',
	/**
	 * @example Path*
/v1/store/features*/
	GetFeatures = 'GetFeatures',
	/**
	 * @example Path*
/v1/store/login*/
	CustomerLogin = 'CustomerLogin',
	/**
	 * @example Path*
/v1/store/business-cards/verify-pin*/
	VerifyBusinessCardPin = 'VerifyBusinessCardPin',
	/**
	 * @example Path*
/v1/store/customer*/
	GetCustomer = 'GetCustomer',
	/**
	 * @example Path*
/v1/store/customer*/
	UpdateCustomer = 'UpdateCustomer',
	/**
	 * @example Path*
/v1/store/customer/accept-terms*/
	AcceptTerms = 'AcceptTerms',
	/**
	 * @example Path*
/v1/store/customer/delete-account*/
	DeleteAccount = 'DeleteAccount',
	/**
	 * @example Path*
/v1/store/customer/cancel-deletion*/
	CancelDeletion = 'CancelDeletion',
	/**
	 * @example Path*
/v1/store/customer/orders*/
	GetCustomerOrders = 'GetCustomerOrders',
	/**
	 * @example Path*
/v1/store/customer/orders/group-by-date*/
	GetCustomerOrdersGroupedByDate = 'GetCustomerOrdersGroupedByDate',
	/**
	 * @example Path*
/v1/store/customer/auth/taktikal/start*/
	TaktikalAuthStart = 'TaktikalAuthStart',
	/**
	 * @example Path*
/v1/store/customer/auth/taktikal/:authRequestUuid*/
	TaktikalAuthPoll = 'TaktikalAuthPoll',
	/**
	 * @example Path*
/v1/store/customer/loyalty-card*/
	GetLoyaltyCard = 'GetLoyaltyCard',
	/**
	 * @example Path*
/v1/store/customer/loyalty-card/wallet-link*/
	GetLoyaltyCardWalletLink = 'GetLoyaltyCardWalletLink',
	/**
	 * @example Path*
/v1/store/customer/loyalty-card/join*/
	JoinLoyaltyProgram = 'JoinLoyaltyProgram',
	/**
	 * @example Path*
/v1/store/customer/loyalty-card/history*/
	GetLoyaltyCardHistory = 'GetLoyaltyCardHistory',
	/**
	 * @example Path*
/v1/store/app-updates*/
	StoreGetAppUpdateBranches = 'StoreGetAppUpdateBranches',
	/**
	 * @example Path*
/v1/store/app-updates/:branchName/updates*/
	StoreGetAppUpdates = 'StoreGetAppUpdates',
	/**
	 * @example Path*
/v1/store/point-of-sale*/
	GetPointOfSaleInfo = 'GetPointOfSaleInfo',
	/**
	 * @example Path*
/v1/store/audit-log*/
	CreateAuditLog = 'CreateAuditLog',
	/**
	 * @example Path*
/v1/store/payment-providers*/
	GetPaymentProviders = 'GetPaymentProviders',
	/**
	 * @example Path*
/v1/store/promotions*/
	GetPromotions = 'GetPromotions',
	/**
	 * @example Path*
/v1/store/sales-channels*/
	ListSalesChannels = 'ListSalesChannels',
	/**
	 * @example Path*
/v1/store/orders*/
	CreateOrder = 'CreateOrder',
	/**
	 * @example Path*
/v1/store/orders/by-ids*/
	GetOrdersByIds = 'GetOrdersByIds',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid*/
	GetOrder = 'GetOrder',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/clear*/
	ClearOrder = 'ClearOrder',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/line-items*/
	AddLineItem = 'AddLineItem',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/line-items/:lineItemUuid*/
	UpdateLineItem = 'UpdateLineItem',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/line-items/:lineItemUuid*/
	DeleteLineItem = 'DeleteLineItem',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/line-items/products/:variantUuid*/
	UpdateProductQuantity = 'UpdateProductQuantity',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/gift-cards/:giftCardUuid*/
	RemoveGiftCard = 'RemoveGiftCard',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/bag-check*/
	GetBagCheckStatus = 'GetBagCheckStatus',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/payment/info*/
	SubmitPaymentInfo = 'SubmitPaymentInfo',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/payment/cancel*/
	CancelOrderPayment = 'CancelOrderPayment',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/validate*/
	ValidateOrder = 'ValidateOrder',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/initiate-payment*/
	InitiateOrderPayment = 'InitiateOrderPayment',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/payment-info*/
	GetOrderPaymentInfo = 'GetOrderPaymentInfo',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/exit-code*/
	GetExitCode = 'GetExitCode',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/receipt*/
	GetOrderReceipt = 'GetOrderReceipt',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/receipt/url*/
	GetOrderReceiptUrl = 'GetOrderReceiptUrl',
	/**
	 * @example Path*
/v1/store/orders/:orderUuid/receipt/pdf*/
	GetOrderReceiptPdf = 'GetOrderReceiptPdf',
	/**
	 * @example Path*
/v1/store/products*/
	GetProducts = 'GetProducts',
	/**
	 * @example Path*
/v1/store/products/categories*/
	GetCategories = 'GetCategories',
	/**
	 * @example Path*
/v1/store/products/groups/:groupUuid*/
	GetProductsFromGroup = 'GetProductsFromGroup',
	/**
	 * @example Path*
/v1/store/products/variants/:variantUuid*/
	GetVariant = 'GetVariant',
	/**
	 * @example Path*
/v1/store/products/:barcode*/
	GetVariantFromBarcode = 'GetVariantFromBarcode'
}

export const EndpointRequestValidators = {
	[Endpoint.GetVersionInfo]: {
		input: z.object({})
	},
	[Endpoint.GetFeatures]: {
		input: z.object({})
	},
	[Endpoint.CustomerLogin]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.VerifyBusinessCardPin]: {
		input: z.object({
			body: z.object({
				cardNumber: z.string(),
				pin: z.string()
			})
		})
	},
	[Endpoint.GetCustomer]: {
		input: z.object({})
	},
	[Endpoint.UpdateCustomer]: {
		input: z.object({
			body: z.object({
				firstName: z.string().optional(),
				lastName: z.string().optional(),
				email: z.string().optional(),
				ssn: z.string().optional()
			})
		})
	},
	[Endpoint.AcceptTerms]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.DeleteAccount]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.CancelDeletion]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetCustomerOrders]: {
		input: z.object({})
	},
	[Endpoint.GetCustomerOrdersGroupedByDate]: {
		input: z.object({})
	},
	[Endpoint.TaktikalAuthStart]: {
		input: z.object({
			body: CustomersTypes.zTaktikalAuthStartRequest
		})
	},
	[Endpoint.TaktikalAuthPoll]: {
		input: z.object({
			path: z.object({
				authRequestUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetLoyaltyCard]: {
		input: z.object({})
	},
	[Endpoint.GetLoyaltyCardWalletLink]: {
		input: z.object({
			query: z.object({
				platform: z.enum(['android', 'ios'])
			})
		})
	},
	[Endpoint.JoinLoyaltyProgram]: {
		input: z.object({
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.GetLoyaltyCardHistory]: {
		input: z.object({
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().default(0)
			})
		})
	},
	[Endpoint.StoreGetAppUpdateBranches]: {
		input: z.object({})
	},
	[Endpoint.StoreGetAppUpdates]: {
		input: z.object({
			path: z.object({
				branchName: z.string().min(1)
			}),
			query: z.object({
				q: z.string().optional(),
				limit: z.coerce.number().min(1).max(100).default(30),
				offset: z.coerce.number().default(0)
			})
		})
	},
	[Endpoint.GetPointOfSaleInfo]: {
		input: z.object({})
	},
	[Endpoint.CreateAuditLog]: {
		input: z.object({
			body: z.object({
				timestamp: z.number(),
				data: z.union([
					SalesChannelsTypes.zEmployeeLoginAuditLog,
					SalesChannelsTypes.zEmployeeLogoutAuditLog,
					SalesChannelsTypes.zDeleteLineItemAuditLog,
					SalesChannelsTypes.zOpenCashDrawerAuditLog,
					SalesChannelsTypes.zOpenCashDrawerManuallyAuditLog,
					SalesChannelsTypes.zReceiptPrintedAuditLog,
					SalesChannelsTypes.zSystemStartAuditLog,
					SalesChannelsTypes.zSystemShutdownAuditLog
				])
			})
		})
	},
	[Endpoint.GetPaymentProviders]: {
		input: z.object({})
	},
	[Endpoint.GetPromotions]: {
		input: z.object({})
	},
	[Endpoint.ListSalesChannels]: {
		input: z.object({})
	},
	[Endpoint.CreateOrder]: {
		input: z.object({
			body: z.object({
				salesChannelUuid: z.string().optional(),
				reuseExistingOrder: z.boolean().optional(),
				items: z.array(OrdersTypes.zAddLineItemBody).optional()
			})
		})
	},
	[Endpoint.GetOrdersByIds]: {
		input: z.object({
			body: z.object({
				uuids: z.array(z.string())
			})
		})
	},
	[Endpoint.GetOrder]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.ClearOrder]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.AddLineItem]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: OrdersTypes.zAddLineItemBody
		})
	},
	[Endpoint.UpdateLineItem]: {
		input: z.object({
			path: z
				.object({
					orderUuid: z.string().min(1)
				})
				.and(
					z.object({
						lineItemUuid: z.string().min(1)
					})
				),
			body: OrdersTypes.zOrderItemChange
		})
	},
	[Endpoint.DeleteLineItem]: {
		input: z.object({
			path: z
				.object({
					orderUuid: z.string().min(1)
				})
				.and(
					z.object({
						lineItemUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.UpdateProductQuantity]: {
		input: z.object({
			path: z
				.object({
					orderUuid: z.string().min(1)
				})
				.and(
					z.object({
						variantUuid: z.string().min(1)
					})
				),
			body: OrdersTypes.zOrderItemChange
		})
	},
	[Endpoint.RemoveGiftCard]: {
		input: z.object({
			path: z
				.object({
					orderUuid: z.string().min(1)
				})
				.and(
					z.object({
						giftCardUuid: z.string().min(1)
					})
				)
		})
	},
	[Endpoint.GetBagCheckStatus]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.SubmitPaymentInfo]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			headers: z.object({
				'x-idempotency-key': z.string()
			}),
			body: z.object({
				clientReference: z.string(),
				provider: z.enum(['VERIFONE_ECOM']),
				data: OrdersTypes.zVerifoneEcomSubmittedPaymentInfo
			})
		})
	},
	[Endpoint.CancelOrderPayment]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			headers: z.object({
				'x-idempotency-key': z.string()
			}),
			body: z.object({
				clientReference: z.string()
			})
		})
	},
	[Endpoint.ValidateOrder]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			body: z.union([z.string().optional().nullable(), z.object({}).strict()])
		})
	},
	[Endpoint.InitiateOrderPayment]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			headers: z.object({
				'x-idempotency-key': z.string()
			}),
			body: OrdersTypes.zOrderInitiatedPaymentInfoBody
		})
	},
	[Endpoint.GetOrderPaymentInfo]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetExitCode]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetOrderReceipt]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			})
		})
	},
	[Endpoint.GetOrderReceiptUrl]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			query: z.object({
				format: z.enum(['pdf', 'html'])
			})
		})
	},
	[Endpoint.GetOrderReceiptPdf]: {
		input: z.object({
			path: z.object({
				orderUuid: z.string().min(1)
			}),
			query: z.object({
				format: z.enum(['pdf', 'html'])
			})
		})
	},
	[Endpoint.GetProducts]: {
		input: z.object({
			query: z.object({
				salesChannelUuid: z.string().optional(),
				q: z.string().optional(),
				limit: z.string().optional(),
				offset: z.string().optional(),
				categoryUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetCategories]: {
		input: z.object({
			query: z.object({
				salesChannelUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetProductsFromGroup]: {
		input: z.object({
			path: z.object({
				groupUuid: z.string().min(1)
			}),
			query: z.object({
				salesChannelUuid: z.string().optional(),
				pricingMethod: CommonTypes.zPricingMethod.optional()
			})
		})
	},
	[Endpoint.GetVariant]: {
		input: z.object({
			path: z.object({
				variantUuid: z.string().min(1)
			}),
			query: z.object({
				salesChannelUuid: z.string().optional()
			})
		})
	},
	[Endpoint.GetVariantFromBarcode]: {
		input: z.object({
			path: z.object({
				barcode: z.string().min(1)
			}),
			query: z.object({
				salesChannelUuid: z.string().optional()
			})
		})
	}
} as const
export const Paths = {
	[Endpoint.StoreGetAppUpdateBranches]: '/v1/store/app-updates',
	[Endpoint.StoreGetAppUpdates]: '/v1/store/app-updates/:branchName/updates',
	[Endpoint.CreateAuditLog]: '/v1/store/audit-log',
	[Endpoint.VerifyBusinessCardPin]: '/v1/store/business-cards/verify-pin',
	[Endpoint.GetCustomer]: '/v1/store/customer',
	[Endpoint.UpdateCustomer]: '/v1/store/customer',
	[Endpoint.AcceptTerms]: '/v1/store/customer/accept-terms',
	[Endpoint.TaktikalAuthPoll]: '/v1/store/customer/auth/taktikal/:authRequestUuid',
	[Endpoint.TaktikalAuthStart]: '/v1/store/customer/auth/taktikal/start',
	[Endpoint.CancelDeletion]: '/v1/store/customer/cancel-deletion',
	[Endpoint.DeleteAccount]: '/v1/store/customer/delete-account',
	[Endpoint.GetLoyaltyCard]: '/v1/store/customer/loyalty-card',
	[Endpoint.GetLoyaltyCardHistory]: '/v1/store/customer/loyalty-card/history',
	[Endpoint.JoinLoyaltyProgram]: '/v1/store/customer/loyalty-card/join',
	[Endpoint.GetLoyaltyCardWalletLink]: '/v1/store/customer/loyalty-card/wallet-link',
	[Endpoint.GetCustomerOrders]: '/v1/store/customer/orders',
	[Endpoint.GetCustomerOrdersGroupedByDate]: '/v1/store/customer/orders/group-by-date',
	[Endpoint.GetFeatures]: '/v1/store/features',
	[Endpoint.CustomerLogin]: '/v1/store/login',
	[Endpoint.CreateOrder]: '/v1/store/orders',
	[Endpoint.GetOrder]: '/v1/store/orders/:orderUuid',
	[Endpoint.GetBagCheckStatus]: '/v1/store/orders/:orderUuid/bag-check',
	[Endpoint.ClearOrder]: '/v1/store/orders/:orderUuid/clear',
	[Endpoint.GetExitCode]: '/v1/store/orders/:orderUuid/exit-code',
	[Endpoint.RemoveGiftCard]: '/v1/store/orders/:orderUuid/gift-cards/:giftCardUuid',
	[Endpoint.InitiateOrderPayment]: '/v1/store/orders/:orderUuid/initiate-payment',
	[Endpoint.AddLineItem]: '/v1/store/orders/:orderUuid/line-items',
	[Endpoint.UpdateLineItem]: '/v1/store/orders/:orderUuid/line-items/:lineItemUuid',
	[Endpoint.DeleteLineItem]: '/v1/store/orders/:orderUuid/line-items/:lineItemUuid',
	[Endpoint.UpdateProductQuantity]: '/v1/store/orders/:orderUuid/line-items/products/:variantUuid',
	[Endpoint.GetOrderPaymentInfo]: '/v1/store/orders/:orderUuid/payment-info',
	[Endpoint.CancelOrderPayment]: '/v1/store/orders/:orderUuid/payment/cancel',
	[Endpoint.SubmitPaymentInfo]: '/v1/store/orders/:orderUuid/payment/info',
	[Endpoint.GetOrderReceipt]: '/v1/store/orders/:orderUuid/receipt',
	[Endpoint.GetOrderReceiptPdf]: '/v1/store/orders/:orderUuid/receipt/pdf',
	[Endpoint.GetOrderReceiptUrl]: '/v1/store/orders/:orderUuid/receipt/url',
	[Endpoint.ValidateOrder]: '/v1/store/orders/:orderUuid/validate',
	[Endpoint.GetOrdersByIds]: '/v1/store/orders/by-ids',
	[Endpoint.GetPaymentProviders]: '/v1/store/payment-providers',
	[Endpoint.GetPointOfSaleInfo]: '/v1/store/point-of-sale',
	[Endpoint.GetProducts]: '/v1/store/products',
	[Endpoint.GetVariantFromBarcode]: '/v1/store/products/:barcode',
	[Endpoint.GetCategories]: '/v1/store/products/categories',
	[Endpoint.GetProductsFromGroup]: '/v1/store/products/groups/:groupUuid',
	[Endpoint.GetVariant]: '/v1/store/products/variants/:variantUuid',
	[Endpoint.GetPromotions]: '/v1/store/promotions',
	[Endpoint.ListSalesChannels]: '/v1/store/sales-channels',
	[Endpoint.GetVersionInfo]: '/v1/store/version-info'
} as const satisfies { [key in Endpoint]: string }

export const Methods = {
	[Endpoint.GetVersionInfo]: HttpMethod.Get,
	[Endpoint.GetFeatures]: HttpMethod.Get,
	[Endpoint.CustomerLogin]: HttpMethod.Post,
	[Endpoint.VerifyBusinessCardPin]: HttpMethod.Post,
	[Endpoint.GetCustomer]: HttpMethod.Get,
	[Endpoint.UpdateCustomer]: HttpMethod.Post,
	[Endpoint.AcceptTerms]: HttpMethod.Post,
	[Endpoint.DeleteAccount]: HttpMethod.Post,
	[Endpoint.CancelDeletion]: HttpMethod.Post,
	[Endpoint.GetCustomerOrders]: HttpMethod.Get,
	[Endpoint.GetCustomerOrdersGroupedByDate]: HttpMethod.Get,
	[Endpoint.TaktikalAuthStart]: HttpMethod.Post,
	[Endpoint.TaktikalAuthPoll]: HttpMethod.Get,
	[Endpoint.GetLoyaltyCard]: HttpMethod.Get,
	[Endpoint.GetLoyaltyCardWalletLink]: HttpMethod.Get,
	[Endpoint.JoinLoyaltyProgram]: HttpMethod.Post,
	[Endpoint.GetLoyaltyCardHistory]: HttpMethod.Get,
	[Endpoint.StoreGetAppUpdateBranches]: HttpMethod.Get,
	[Endpoint.StoreGetAppUpdates]: HttpMethod.Get,
	[Endpoint.GetPointOfSaleInfo]: HttpMethod.Get,
	[Endpoint.CreateAuditLog]: HttpMethod.Post,
	[Endpoint.GetPaymentProviders]: HttpMethod.Get,
	[Endpoint.GetPromotions]: HttpMethod.Get,
	[Endpoint.ListSalesChannels]: HttpMethod.Get,
	[Endpoint.CreateOrder]: HttpMethod.Post,
	[Endpoint.GetOrdersByIds]: HttpMethod.Post,
	[Endpoint.GetOrder]: HttpMethod.Get,
	[Endpoint.ClearOrder]: HttpMethod.Post,
	[Endpoint.AddLineItem]: HttpMethod.Post,
	[Endpoint.UpdateLineItem]: HttpMethod.Post,
	[Endpoint.DeleteLineItem]: HttpMethod.Delete,
	[Endpoint.UpdateProductQuantity]: HttpMethod.Post,
	[Endpoint.RemoveGiftCard]: HttpMethod.Delete,
	[Endpoint.GetBagCheckStatus]: HttpMethod.Get,
	[Endpoint.SubmitPaymentInfo]: HttpMethod.Post,
	[Endpoint.CancelOrderPayment]: HttpMethod.Post,
	[Endpoint.ValidateOrder]: HttpMethod.Post,
	[Endpoint.InitiateOrderPayment]: HttpMethod.Post,
	[Endpoint.GetOrderPaymentInfo]: HttpMethod.Get,
	[Endpoint.GetExitCode]: HttpMethod.Get,
	[Endpoint.GetOrderReceipt]: HttpMethod.Get,
	[Endpoint.GetOrderReceiptUrl]: HttpMethod.Get,
	[Endpoint.GetOrderReceiptPdf]: HttpMethod.Get,
	[Endpoint.GetProducts]: HttpMethod.Get,
	[Endpoint.GetCategories]: HttpMethod.Get,
	[Endpoint.GetProductsFromGroup]: HttpMethod.Get,
	[Endpoint.GetVariant]: HttpMethod.Get,
	[Endpoint.GetVariantFromBarcode]: HttpMethod.Get
} as const satisfies { [key in Endpoint]: HttpMethod }

// Explicit endpoint type definitions (no z.infer)
export type EndpointDefinitions =
	| {
			endpoint: Endpoint.GetVersionInfo
			input: never
			response: RootTypes.VersionInfo
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetFeatures
			input: never
			response: RootTypes.TenantFeatures
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.CustomerLogin
			input: never
			response: {
				token: string
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.VerifyBusinessCardPin
			input: {
				body: {
					cardNumber: string
					pin: string
				}
			}
			response: {
				success: boolean
				error?: 'INVALID_INPUT' | 'INVALID_PIN' | 'CARD_BLOCKED' | 'CARD_NOT_FOUND' | 'CARD_INACTIVE'
				message?: string
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetCustomer
			input: never
			response: CustomersTypes.Customer
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.UpdateCustomer
			input: {
				body: {
					firstName?: string
					lastName?: string
					email?: string
					ssn?: string
				}
			}
			response: CustomersTypes.Customer
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.AcceptTerms
			input: never
			response: CustomersTypes.Customer
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.DeleteAccount
			input: never
			response: Record<never, never>
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.CancelDeletion
			input: never
			response: CustomersTypes.Customer
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetCustomerOrders
			input: never
			response: CustomersTypes.OrderListItem[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetCustomerOrdersGroupedByDate
			input: never
			response: {
				date: number
				orders: CustomersTypes.OrderListItem[]
			}[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.TaktikalAuthStart
			input: {
				body: CustomersTypes.TaktikalAuthStartRequest
			}
			response: CustomersTypes.TaktikalAuthStartResponse
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.TaktikalAuthPoll
			input: {
				path: {
					authRequestUuid: string
				}
			}
			response: CustomersTypes.TaktikalAuthPollResponse
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetLoyaltyCard
			input: never
			response: StoreLoyaltyCardTypes.LoyaltyCard
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetLoyaltyCardWalletLink
			input: {
				query: {
					platform: 'android' | 'ios'
				}
			}
			response: {
				url?: string
				jwt?: string
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.JoinLoyaltyProgram
			input: never
			response: {
				success: boolean
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetLoyaltyCardHistory
			input: {
				query: {
					q?: string
					limit?: number
					offset?: number
				}
			}
			response: {
				redemptions: StoreLoyaltyCardTypes.LoyaltyCardRedemption[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.StoreGetAppUpdateBranches
			input: never
			response: {
				branches: CommonTypes.AppUpdateBranch[]
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.StoreGetAppUpdates
			input: {
				path: {
					branchName: string
				}
				query: {
					q?: string
					limit?: number
					offset?: number
				}
			}
			response: {
				updates: CommonTypes.AppUpdate[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetPointOfSaleInfo
			input: never
			response: {
				identifier: string
				name: string
				metadata: any
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.CreateAuditLog
			input: {
				body: {
					timestamp: number
					data:
						| SalesChannelsTypes.EmployeeLoginAuditLog
						| SalesChannelsTypes.EmployeeLogoutAuditLog
						| SalesChannelsTypes.DeleteLineItemAuditLog
						| SalesChannelsTypes.OpenCashDrawerAuditLog
						| SalesChannelsTypes.OpenCashDrawerManuallyAuditLog
						| SalesChannelsTypes.ReceiptPrintedAuditLog
						| SalesChannelsTypes.SystemStartAuditLog
						| SalesChannelsTypes.SystemShutdownAuditLog
				}
			}
			response: {
				success: boolean
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetPaymentProviders
			input: never
			response: OrdersTypes.PaymentProviderConfig[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetPromotions
			input: never
			response: SalesChannelsTypes.Promotion[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.ListSalesChannels
			input: never
			response: SalesChannelsTypes.SalesChannel[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.CreateOrder
			input: {
				body: {
					salesChannelUuid?: string
					reuseExistingOrder?: boolean
					items?: OrdersTypes.AddLineItemBody[]
				}
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetOrdersByIds
			input: {
				body: {
					uuids: string[]
				}
			}
			response: OrdersTypes.Order[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetOrder
			input: {
				path: {
					orderUuid: string
				}
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.ClearOrder
			input: {
				path: {
					orderUuid: string
				}
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.AddLineItem
			input: {
				path: {
					orderUuid: string
				}
				body: OrdersTypes.AddLineItemBody
			}
			response: {
				change: {
					itemUuid?: string
					groupUuid?: string
					giftCardUuid?: string
				}
				order: OrdersTypes.Order
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.UpdateLineItem
			input: {
				path: {
					orderUuid: string
				} & {
					lineItemUuid: string
				}
				body: OrdersTypes.OrderItemChange
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.DeleteLineItem
			input: {
				path: {
					orderUuid: string
				} & {
					lineItemUuid: string
				}
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.UpdateProductQuantity
			input: {
				path: {
					orderUuid: string
				} & {
					variantUuid: string
				}
				body: OrdersTypes.OrderItemChange
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.RemoveGiftCard
			input: {
				path: {
					orderUuid: string
				} & {
					giftCardUuid: string
				}
			}
			response: OrdersTypes.Order
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetBagCheckStatus
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				status: CommonTypes.OrderBagCheckStatusType
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.SubmitPaymentInfo
			input: {
				path: {
					orderUuid: string
				}
				headers: {
					'x-idempotency-key': string
				}
				body: {
					clientReference: string
					provider: 'VERIFONE_ECOM'
					data: OrdersTypes.VerifoneEcomSubmittedPaymentInfo
				}
			}
			response: CommonTypes.GenericSuccess
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.CancelOrderPayment
			input: {
				path: {
					orderUuid: string
				}
				headers: {
					'x-idempotency-key': string
				}
				body: {
					clientReference: string
				}
			}
			response: CommonTypes.GenericSuccess
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.ValidateOrder
			input: {
				path: {
					orderUuid: string
				}
			}
			response: {
				hasChanges: boolean
				amountDiff: CommonTypes.Amount
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.InitiateOrderPayment
			input: {
				path: {
					orderUuid: string
				}
				headers: {
					'x-idempotency-key': string
				}
				body: OrdersTypes.OrderInitiatedPaymentInfoBody
			}
			response: CommonTypes.GenericSuccess
			errorResponses: {
				isSuccess: false
				status: 409
				response: {
					success: false
					type: 'PRICE_MISMATCH'
				}
			}
	  }
	| {
			endpoint: Endpoint.GetOrderPaymentInfo
			input: {
				path: {
					orderUuid: string
				}
			}
			response: OrdersTypes.OrderPaymentInfoResponse
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetExitCode
			input: {
				path: {
					orderUuid: string
				}
			}
			response:
				| {
						enabled: true
						format: string
						exitCode: string
				  }
				| {
						enabled: false
				  }
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetOrderReceipt
			input: {
				path: {
					orderUuid: string
				}
			}
			response: string
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetOrderReceiptUrl
			input: {
				path: {
					orderUuid: string
				}
				query: {
					format: 'pdf' | 'html'
				}
			}
			response: {
				url: string
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetOrderReceiptPdf
			input: {
				path: {
					orderUuid: string
				}
				query: {
					format: 'pdf' | 'html'
				}
			}
			response: void
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetProducts
			input: {
				query: {
					salesChannelUuid?: string
					q?: string
					limit?: string
					offset?: string
					categoryUuid?: string
				}
			}
			response: {
				items: ProductsTypes.ProductVariant[]
				count: number
				limit: number
				offset: number
			}
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetCategories
			input: {
				query: {
					salesChannelUuid?: string
				}
			}
			response: {
				uuid: string
				name: string
			}[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetProductsFromGroup
			input: {
				path: {
					groupUuid: string
				}
				query: {
					salesChannelUuid?: string
					pricingMethod?: CommonTypes.PricingMethodType
				}
			}
			response: ProductsTypes.ProductVariant[]
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetVariant
			input: {
				path: {
					variantUuid: string
				}
				query: {
					salesChannelUuid?: string
				}
			}
			response: ProductsTypes.ProductVariant
			errorResponses: never
	  }
	| {
			endpoint: Endpoint.GetVariantFromBarcode
			input: {
				path: {
					barcode: string
				}
				query: {
					salesChannelUuid?: string
				}
			}
			response: ProductsTypes.ProductVariant & {
				price: CommonTypes.TaxAmount
			}
			errorResponses: never
	  }

export type EndpointInput<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['input'] extends never
	? Record<string, never>
	: Extract<EndpointDefinitions, { endpoint: T }>['input']
export type EndpointPath<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { path: infer P } ? P : TDefault
export type EndpointBody<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { body: infer B } ? B : TDefault
export type EndpointQuery<T extends Endpoint, TDefault = never> =
	EndpointInput<T> extends { query: infer Q } ? Q : TDefault
export type EndpointResponse<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['response']
export type EndpointErrorResponses<T extends Endpoint> = Extract<EndpointDefinitions, { endpoint: T }>['errorResponses']
export type EndpointPathAndQueryUnion<T extends Endpoint> = EndpointPath<T, unknown> & EndpointQuery<T, unknown>
export type EndpointNoThrowResult<T extends Endpoint> =
	| { isSuccess: true; status: number; response: EndpointResponse<T>; raw?: AxiosResponse }
	| ({
			isSuccess: false
			status: number
			error?: any
	  } & NonNullable<EndpointErrorResponses<T>>)
